import React from "react"
import { Button, Card, Col, Form, ListGroup, Row } from "react-bootstrap"
import withHooks from "../../Common/jsx/WithHooks"
import { ucFirst } from "../../Common/js/generic_functions"
import Badge from "react-bootstrap/Badge"
import Stack from "react-bootstrap/Stack"
import { ErrorMessage, Field, Formik } from "formik"
import * as Yup from "yup"

class QuestionNumSuiteInput extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {
      isReadyToRender: true,
      enteredAnswer: { answerValue: "" },
      bgColorVariant: "",
    }

    this.correctAnswer = this.props.currentQuestion.responseChoices[0]
    this.correctValue = parseFloat(this.correctAnswer["response" + ucFirst(this.props.i18n.resolvedLanguage)])

    this.dMgr.debug("init_state:", this.state)

    this.displayJustification = this.displayJustification.bind(this)
    this.getFormValidationSchema = this.getFormValidationSchema.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    this.dMgr.debug("componentDidMount:", this.props.answerGiven)

    if (this.props.answerGiven) {
      // let answerValue = parseFloat(this.props.currentQuestion.responseChoices[0]["response" + ucFirst(this.props.i18n.resolvedLanguage)])
      // this.props.updatePlayScore(-1)
      // this.setState({ bgColorVariant: "background-color-danger", enteredAnswer: { answerValue } })
    }
  }

  handleSubmit(values, { setSubmitting }) {
    if (this.state.enteredAnswer.answerValue === "") {
      this.dMgr.debug("handleSubmit:", values)

      let answerValue = parseFloat(values.answerValue)
      if (isNaN(answerValue)) {
        answerValue = 0
      }

      this.dMgr.debug("answerValue:", answerValue, "correctValue:", this.correctValue)

      let bgColorVariant
      if (answerValue === this.correctValue) {
        bgColorVariant = "background-color-success"
        this.props.updatePlayScore(1)
      } else {
        bgColorVariant = "background-color-danger"
        this.props.updatePlayScore(-1)
      }
      this.setState({ bgColorVariant, enteredAnswer: { answerValue } })
      this.props.setChosenAnswer(this.correctAnswer)

      setSubmitting(false)
    }
  }

  displayJustification() {
    this.dMgr.debug("displayJustification:")
    this.setState({ displayJustification: true })
  }

  getFormValidationSchema() {
    // CONFIG ==================================================================================================
    return Yup.object().shape({
      answerValue: Yup.string().required(this.props.t("message.required")),
    })
    // /CONFIG =================================================================================================
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    console.log(this.props)
    console.log(this.props.answerGiven, this.state.bgColorVariant)

    let toRender = (
      <Row className="margin-top-15 margin-bottom-10">
        <Col md={3}></Col>
        <Col md={6}>
          <Card>
            <Card.Body className="bg-dark text-white text-center">
              <div className="font-size-11">
                {this.props.t("entity.question")} #{this.props.currentQuestion.id} - {this.props.currentQuestion.questionType["name" + ucFirst(this.props.i18n.resolvedLanguage)]}
              </div>
              <div className="margin-top-30 margin-bottom-10 font-weight-bold">{this.props.currentQuestion.questionType["commonStatement" + ucFirst(this.props.i18n.resolvedLanguage)]}</div>
              <Stack className="justify-content-center" direction="horizontal" gap={3}>
                {this.props.currentQuestion["statement" + ucFirst(this.props.i18n.resolvedLanguage)].split("|").map((statement, index) => {
                  let background = "black"
                  let text = "white"
                  if (statement === "?") {
                    background = "warning"
                    text = "black"
                  }
                  return (
                    <Badge key={"statement_" + this.props.currentQuestion.id + "_" + index} bg={background} className={"text-" + text}>
                      {statement}
                    </Badge>
                  )
                })}
              </Stack>

              <Formik enableReinitialize initialValues={this.state.enteredAnswer} validationSchema={this.getFormValidationSchema} onSubmit={this.handleSubmit}>
                {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
                  <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    {/* {console.log("Formik values:", values)}
                    {console.log("Formik errors:", errors)}
                    {console.log("Formik touched:", touched)} */}

                    <Form.Group controlId="formAnswerValue" className="margin-top-30 width-200 display-inline-flex">
                      <Field
                        as={Form.Control}
                        name="answerValue"
                        isInvalid={touched.answerValue && errors.answerValue}
                        onChange={handleChange}
                        value={!this.props.answerGiven ? values.answerValue : this.correctValue}
                        disabled={this.state.enteredAnswer.answerValue !== "" || this.props.answerGiven}
                        className={"border-color-black text-center " + (!this.props.answerGiven ? this.state.bgColorVariant : "background-color-warning")}
                      />
                      <Form.Control.Feedback type="bgalid"></Form.Control.Feedback>

                      {this.state.enteredAnswer.answerValue === "" && !this.props.answerGiven && (
                        <Button id="btn-submit" variant="primary" size="sm" type="submit" className="button-color1 margin-left-5">
                          {this.props.t("action.validate")}
                        </Button>
                      )}

                      {(this.state.enteredAnswer.answerValue !== "" || this.props.answerGiven) && !this.state.displayJustification && (
                        <Button
                          className="button-color1 margin-left-5"
                          size="sm"
                          onClick={() => {
                            this.setState({ displayJustification: true })
                          }}
                        >
                          {this.props.t("app.justification")}
                        </Button>
                      )}
                    </Form.Group>
                  </Form>
                )}
              </Formik>

              {this.state.displayJustification && (
                <div>
                  <br />
                  {this.correctAnswer["justification" + ucFirst(this.props.i18n.resolvedLanguage)].split("|").map((responseElement, index) => {
                    if (responseElement === "") {
                      responseElement = <br />
                    }

                    return <div key={"responseElement" + index}>{responseElement}</div>
                  })}
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(QuestionNumSuiteInput)
